<main class="mx-auto flex min-h-[60vh] w-full max-w-4xl flex-col items-center px-4 pb-16 pt-10">
  <p class="text-sm font-semibold text-primary/80">Access restricted</p>

  <h1 class="mt-4 text-center text-3xl font-semibold tracking-tight text-heading sm:text-4xl">
    You don’t have access to this page
  </h1>

  <p class="mt-4 max-w-xl text-center text-base text-body">
    Your account doesn’t currently have permission to use this part of the app.
    If you believe this is a mistake, please contact support or your account manager.
  </p>

  <section class="mt-10 w-full max-w-md">
    <h2 class="sr-only">Go to another page</h2>

    <ul class="divide-y divide-border rounded-xl border border-border bg-surface-elevated">
      @for (item of routes; track item.route) {
        <li class="group">
          <a
            [routerLink]="item.route"
            class="flex items-center justify-between gap-x-3 px-4 py-3 text-sm font-medium text-primary transition-colors hover:bg-surface-subtle"
          >
            <span>{{ item.label }}</span>
            <span class="inline-flex size-6 items-center justify-center rounded-full bg-primary/5 text-primary">
              <svg
                class="size-3.5"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
          </a>
        </li>
      }
    </ul>
  </section>
</main>

